module.exports = __webpack_public_path__ + "img/LuckyWheel.7b7a0893.png";